import styled, { css } from 'styled-components';
import { StyleVars, getColor } from 'core/utils';
import { Link } from 'react-scroll';

export const StyledWrapper = styled.div`
	width: 100%;
	background: ${getColor('primaryBrand')};
	color: ${getColor('gray0')};
	z-index: 10;
	justify-content: left;
	align-items: left;
	padding: 8px 18px;
	display: flex;
	flex-direction: column;

	transition: bottom 0.9s linear;


	${({ isSticky }) => !isSticky && css`
		height: 0px;
		padding: 0;
		border: 0;
		width: 100%;
		* {
			display: none;
		}
	`}
`;

export const ChooseButton = styled.button`
	height: 40px;
	width: 100%;
	font-size: 14px;
	font-weight: 800;
	border: none;
	border-radius: 8px;
	color: black;
	outline: none;
	background: white;
`;

export const Title = styled.div`
	font-size: 26px;
	font-weight: 600;
	line-height: 1;
`;

export const StoreLink = styled.a`
	text-decoration: underline;
	font-size: 12px;
	color: white;
	margin-bottom: 12px;
	&:hover, &:active, &:focus {
		color: white;
	}
`;

export const MoreProductsLink = styled(Link)`
	text-decoration: underline;
	font-size: 12px;
	color: white;
	margin-bottom: 12px;
`;
